<script>
import { onMount, onDestroy } from 'svelte';
import { browser } from '$app/environment';
import { invalidateAll } from '$app/navigation';

import { jsonDeepStrictEqual } from '$lib/universal/lib.js';
import { button_disable, button_enable, handleFetch, handleFetchReject,
    find_user_bounds, map_settings_add_defaults, getFormState } from '$lib/app/lib.js';
import { tooltip } from '$lib/app/tooltip.js';
import { uuid } from '$lib/app/uuid.js';


import AddOnButtons from '$lib/AddOnButtons.svelte';
import MapSelector from '$lib/app/MapSelector.svelte';

let {
    map = null,
    map_settings = $bindable({}),
    map_settings_override = $bindable({})
} = $props();

onMount(() => {
    map_settings_override = { hover: 'auto' };
    setFormState("map-style-form", map_settings);
    disableIrrelevantControls();
});

onDestroy(() => {
    map_settings_override = {};
});


$effect(() => {
    setFormState("map-style-form", map_settings);
    disableIrrelevantControls();
});


// Disable/enable irrelevant controls (if they exist on the page)
function disableIrrelevantControls() {
    if (!browser) return;

    const new_form_state = getFormState('map-style-form');

    if(jsonDeepStrictEqual(map_settings, new_form_state)) {
        button_disable('b_save', {is_loading: false});
    } else {
        button_enable('b_save');
    }

    if(new_form_state?.["show-locations"] == 'points' || new_form_state?.["show-locations"] == 'heatmap-points') {
        document.getElementById('circle-color')?.classList.remove("disabled");
        document.getElementById('circle-stroke-color')?.classList.remove("disabled");
    } else {
        document.getElementById('circle-color')?.classList.add("disabled");
        document.getElementById('circle-stroke-color')?.classList.add("disabled");
    }

    if(new_form_state?.["show-locations"] == 'heatmap' || new_form_state?.["show-locations"] == 'heatmap-points') {
        document.getElementById('heatmap-color')?.classList.remove("disabled");
    } else {
        document.getElementById('heatmap-color')?.classList.add("disabled");
    }

    if(new_form_state?.["highlight-countries"] === 'no' || new_form_state?.["highlight-countries"] === 'grad') {
        document.getElementById('highlight-color')?.classList.add("disabled");
    } else {
        document.getElementById('highlight-color')?.classList.remove("disabled");
    }
}

function handleMapStyleForm(e) {
    if (!browser) return;

    const the_button = e.currentTarget;

    const form_state = getFormState('map-style-form'); // try to get style from the live map style settings form embedded to the current page
    if(!form_state) {
        return;
    }

    // Remove previous error/OK message
    let error_in_api = document.getElementById("error_in_api");
    if(error_in_api) error_in_api.innerHTML = "";

    // View changed
    if(the_button?.name == 'view') {
        map.fitBounds(find_user_bounds(form_state), {
                    duration: 500,
                    essential: false
                });
    }

    disableIrrelevantControls(form_state);

    //This needs to refactored when I know SvelteKit and JS better
    //let user_data_copy = $user_data;
    //user_data_copy.map_settings = form_state;
    
    //const user_data_copy = { ... $user_data, map_settings: form_state };
    //user_data_copy.map_settings.editable = true;

    /*
    const user_data_copy = { ... $user_data, map_settings: { ... form_state, editable: true, map_bounds: map_settings?.map_bounds } };

    map_apply_settings(map, user_data_copy);
    */
    map_settings_override = { ... form_state, map_bounds: map_settings?.map_bounds, hover: 'auto' };
}


function saveMapSettings(e /*, the_button*/) {
    if (!browser) return;

    e.preventDefault();

    const the_button = e.currentTarget;
    //e.preventDefault();

    const error_in_api = document.getElementById("error_in_api");
    //const user_id = document.getElementById("user_id").value;

    /*if(user_id == 0) {
        show_login_signup_form(false, 'login-form');
        return;
    }*/

    const formData = new FormData();
    //formData.append('user_id', user_id);
    //formData.append('api_key', document.getElementById("api_key").value);
    let style_form_state = getFormState('map-style-form');
    ///???delete style_form_state.api_key;
    ///???delete style_form_state.user_id;
    if(style_form_state['view'] == 'custom') {
        map_settings["map_bounds"] = style_form_state['map_bounds'] = map.getBounds().toArray();
        //???map_settings = map_settings; //?reactivity? I want the save to hidden field
    } else {
        style_form_state['map_bounds'] = map_settings["map_bounds"];
    }
    //console.log(JSON.stringify(style_form_state));
    //formData.append('update_map_settings', JSON.stringify(style_form_state));
    formData.append('update-map-settings', JSON.stringify(style_form_state));
    if(uuid) {
        formData.append('uuid', uuid);
    }

    button_disable(the_button);

    fetch('/_api/acc/update-map-settings', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
    })
    .then(handleFetch, handleFetchReject)
    .then((data) => { // Parsed JSON passed as `data`
        //error_in_api.innerHTML = "***";
        if(data["error"]) {
            //console.log("error1>" + JSON.stringify(data));
            error_in_api.classList.remove("is-success");
            error_in_api.classList.add("is-danger");
            error_in_api.innerHTML = data["error"];
            button_enable(the_button);
        } else if(data["message"]) {
            //console.log("message>" + JSON.stringify(data));
            map_settings  = getFormState('map-style-form');
            button_disable(the_button, {is_loading: false});
            error_in_api.classList.remove("is-danger");
            error_in_api.classList.add("is-success");
            error_in_api.innerHTML = data["message"];
            invalidateAll();


        } else {
            error_in_api.innerHTML = '???';
            button_enable(the_button);
        }
        //console.log(JSON.stringify(data));
    });/*
    .catch((error) => {
        error_in_api.innerHTML = "!!!";
        //console.log("error2>" + JSON.stringify(error));
        error_in_api.innerHTML = error;
        button_enable(the_button);
    });*/
}


function setFormState(id, form_state) {
    if (!browser) return;

    form_state = map_settings_add_defaults(form_state);

    const form = document.getElementById(id);
    for (const [key, value] of Object.entries(form_state)) {
        let controls = document.getElementsByName(key);
        for (let i=0; i < controls.length; i++) {
            if(controls[i].tagName.toUpperCase() == "BUTTON") {
                if(value === controls[i].value) {
                    controls[i].classList.add("is-selected", "is-link");
                } else {
                    controls[i].classList.remove("is-selected", "is-link");
                }
            }
            if(controls[i].tagName.toUpperCase() == "INPUT") {
                if(controls[i].type.toLowerCase() == "radio") {
                    if(value === controls[i].value) {
                        controls[i].checked = true;
                    } else {
                        controls[i].checked = false;
                    }
                } else if(controls[i].type.toLowerCase() == "hidden") {
                    controls[i].value = value;
                }
            }
        }
    }
}

</script>


<form id="map-style-form" novalidate="novalidate"  >
    <!--input type="hidden" id="map_bounds" name="map_bounds" value="{map_settings?.map_bounds}-->
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="style" class="label">Map style</label>
        </div>
        <div id="style" class="field-body">
            <MapSelector id="style" selected={map_settings.style} variant="desktop" onclick={handleMapStyleForm}/>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="view" class="label">Map view</label>
        </div>
        <div class="field-body">
            <AddOnButtons 
                id="view" 
                onclick={handleMapStyleForm}
                buttons = {[
                    {value: "world", html: "World", help: "The whole world"},
                    {value: "been", html: "Been", help: "The world you've seen"},
                    {value: "europe", html: "Europe", help: "Europe"},
                    {value: "custom", html: "Custom", help: "Pan and zoom the map to get the desired view, then press Save"},
                ]}
                form={map_settings}
            />
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="highlight-countries" class="label">Highlight visited</label>
        </div>
        <div class="field-body">
            <AddOnButtons 
                id="highlight-countries" 
                onclick={handleMapStyleForm}
                buttons = {[
                    {value: "reg", html: "Regions", help: "Highlight visited <a target=_blank href='/info/our-regions#Regions'>regions</a> (states, provinces, oblasts, archipelagos, etc)"},
                    {value: "yes", html: "Countries", help: "Highlight visited <a target=_blank href='/info/our-regions#UN+'>UN+ Countries</a>"},
                    {value: "tcc", html: "TCC", help: "Highlight <a target=_blank href='/info/our-regions#UN+'>Travelers’ Century Club®’s countries and territories</a>"},
                    {value: "no", html: "Off", help: "&nbsp;"},
                ]}
                form={map_settings}
            />
        </div>
    </div>    

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="highlight-color" class="label">Highlight color</label>
        </div>
        <div id="highlight-color" class="field-body control">
            <div class="control">
                <label class="radio" >
                    <input type="radio" name="highlight-color" value="#f6a192" style="accent-color: #f6a192;" onclick={handleMapStyleForm}>
                    <span class="rose-underline">Rose</span>
                </label>
                <label class="radio"><!--value="#fbb03b" A7-->
                    <input type="radio" name="highlight-color" value="#FF7700" style="accent-color: #FCD6A9;" onclick={handleMapStyleForm}>
                    <span class="honey-underline">Honey</span>
                </label>
                <label class="radio" >
                    <input type="radio" name="highlight-color" value="#4264fb" style="accent-color: #CED1E4;" onclick={handleMapStyleForm}>
                    <span class="light-purple-underline">Purple</span>
                </label>
                <label class="radio" >
                    <input type="radio" name="highlight-color" value="#0080ff" style="accent-color: #BFD7E5;" onclick={handleMapStyleForm}>
                    <span class="blue-underline">Blue</span>
                </label>
                <label class="radio" >
                    <input type="radio" name="highlight-color" value="#3bb2d0" style="accent-color: #CCE4DA;" onclick={handleMapStyleForm}>
                    <span class="cyan-underline">Cyan</span>
                </label>
                <label class="radio"><!-- 262626 -->
                    <input type="radio" name="highlight-color" value="#100525" style="accent-color: #787878;" onclick={handleMapStyleForm}>
                    Black
                </label>
                <label class="radio"><!-- 262626 -->
                    <input type="radio" name="highlight-color" value="#FFFFFF" onclick={handleMapStyleForm}>
                    White
                </label>
            <br/>
                <label class="radio" use:tooltip
                data-tooltip={`Like a classroom wall map,
each country is in a distinct color`}>
                    <input type="radio" name="highlight-color" value="political" onclick={handleMapStyleForm}>
                    <svg class='svg-icon'><use xlink:href='/i/fa.svg#map'></use></svg>&hairsp;Political
                </label>
                <label class="radio" use:tooltip
                data-tooltip={`Country shading reflects the depth of knowledge:
the more regions visited, the deeper and more 'violet' the color`}>
                    <input type="radio" name="highlight-color" value="choropleth" onclick={handleMapStyleForm}>
                    <svg class='svg-icon'><use xlink:href='/i/fa.svg#chart-simple'></use></svg>&hairsp;Choropleth
                </label>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="show-locations" class="label">Visited cities</label>
        </div>
        <div id="show-locations" class="field-body">
            <AddOnButtons 
                id="show-locations" 
                onclick={handleMapStyleForm}
                buttons = {[
                    {value: "points", html: "Points", help: "&nbsp;"},
                    {value: "heatmap-points", html: "Heatmap&#xFF0B;Points", help: "&nbsp;"},
                    {value: "heatmap", html: "Heatmap", help: "Your visited points will be visible to you only"},
                    {value: "off", html: "Hide", help: "Your visited points will be visible to you only"},
                ]}
                form={map_settings}
            />
        </div>
    </div>    

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="circle-color" class="label correct-bulma-label">Point color</label>
        </div>
        <div id="circle-color" class="field-body control">
            <div class="control">
                <label class="radio">
                    <input type="radio" name="circle-color" value="#e55e5e" style="accent-color: #e55e5e;" onclick={handleMapStyleForm}>
                    <span class="red-underline">Red</span>
                </label>
                <label class="radio">
                    <input type="radio" name="circle-color" value="#f6a192" style="accent-color: #f6a192;" onclick={handleMapStyleForm}>
                    <span class="rose-underline">Rose</span>
                </label>
                <label class="radio">
                    <input type="radio" name="circle-color" value= "#fbb03b" style="accent-color: #fbb03b;" onclick={handleMapStyleForm}>
                    <span class="yellow-underline">Yellow</span>
                </label>
                <label class="radio">
                    <input type="radio" name="circle-color" value="#4264fb" style="accent-color: #4264fb;" onclick={handleMapStyleForm}>
                    <span class="blue-point-underline">Blue</span>
                </label>
                <label class="radio">
                    <input type="radio" name="circle-color" value="#3bb2d0" style="accent-color: #3bb2d0;" onclick={handleMapStyleForm}>
                    <span class="light-blue-underline">Light Blue</span>
                </label>
                <label class="radio">   
                    <input type="radio" name="circle-color" value="#ffffff" onclick={handleMapStyleForm}>
                    White
                </label>
                <label class="radio">
                    <input type="radio" name="circle-color" value="#787878" style="accent-color: #787878;" onclick={handleMapStyleForm}>
                    Grey
                </label>
                <label class="radio">
                    <input type="radio" name="circle-color" value="#262626" style="accent-color: #262626;" onclick={handleMapStyleForm}>
                    Black
                </label>
            </div>
        </div>
    </div>

    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label for="circle-stroke-color" class="label correct-bulma-label">Point border</label>
        </div>
        <div id="circle-stroke-color" class="field-body control">
            <div class="control">
                <label class="radio">
                    <input type="radio" name="circle-stroke-color" value="#ffffff" onclick={handleMapStyleForm}>
                    White
                </label>
                <label class="radio">
                    <input type="radio" name="circle-stroke-color" value="#262626" style="accent-color: #262626;" onclick={handleMapStyleForm}>
                    Black
                </label>
            </div>
        </div>
    </div>            

    <div class="field is-horizontal " >
        <div class="field-label is-normal">
            <label for="heatmap-color" class="label correct-bulma-label">Heatmap colors</label>
        </div>
        <div id="heatmap-color" class="field-body control" >
            <div class="control">
                <label class="radio">
                    <input type="radio" name="heatmap-color" value="1" onclick={handleMapStyleForm}>
                    Red-Yellow
                </label>
                <label class="radio">
                    <input type="radio" name="heatmap-color" value="2"  onclick={handleMapStyleForm}>
                    Red-Blue
                </label>
                <label class="radio">
                    <input type="radio" name="heatmap-color" value="3"  onclick={handleMapStyleForm}>
                    RGB
                </label>
                <label class="radio" use:tooltip data-tooltip={`Uses point color and point border color`}>
                    <input type="radio" name="heatmap-color" value="0"  onclick={handleMapStyleForm}>
                    Auto
                </label>
            </div>
        </div>
    </div>            


    <div class="field is-horizontal">
        <div class="field-label">
            <!-- Left empty for spacing -->
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <button id="b_save" class="button is-link"  onclick={saveMapSettings}>
                        <svg class='svg-icon'><use xlink:href='/i/fa.svg#floppy-disk'></use></svg>&nbsp;<span>Save</span>
                    </button>
                </div>
                <div id="error_in_api" class="help is-danger"></div>
            </div>
        </div>
    </div>

</form>


<style>
.correct-bulma-label {
    margin-top: -7px;
}
.red-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #e55e5e;
}
.light-purple-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #CED1E4;
}
.rose-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #f6a192;
}
.honey-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #FCD6A9;
}
.yellow-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #fbb03b;
}
.blue-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #BFD7E5;
}
.blue-point-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #0080ff;
}
.light-blue-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #3bb2d0;
}
.cyan-underline {
    text-decoration: none;
    box-shadow: inset 0 -6px 0 #CCE4DA;
}
@media (prefers-color-scheme: dark) {
    .honey-underline, .cyan-underline, .light-blue-underline, .blue-point-underline,
    .blue-underline, .yellow-underline, .honey-underline, .rose-underline,
    .light-purple-underline, .red-underline   {
        text-shadow: 1px 1px 1px black;
    }
}
</style>
